import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/Success";

const SuccessGardens = () => {
  const projectId = 55;
  const title = "Success Gardens";

  const mapConfig = {
    minZoom: 5,
    zoom: 6,
    bounds: [
      [36.34, -187.54],
      [21.56, -160.52],
    ],
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/properties/success-gardens-phase-2-gatanga-road-thika/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSd2tt26kkMoiTWuwo9ZcpnjI3-cjUbCVm_Pton9zlMNMhq0RA/viewform"
    />
  );
};

export default SuccessGardens;
